import { useSelector } from 'react-redux'
import { UseTimeZone } from '../../../common/hooks/useTimeZone'
import EventEmitter, { SHOW_POPUP_UPGRADE } from '../../../helpers/EventEmitter'
import {
  selectComponentAuthorized,
  selectUserType,
} from '../../../layout/store/slice'
import { AUTHORIZATION_TYPE } from '../../../utils/authorization'
import { selectCompanyInfo } from '../../common/header/companyInfo/store/slice'
import { HighlightInformation } from '../../common/header/highlightInformation'
import { selectHighlight, selectLoading } from '../store/slice'
import { getHighlightData } from './helper'

export const Content = ({ setIsShowPreferenceSetting }) => {
  const locale = useSelector((state) => state.i18n.locale)
  const timezone = UseTimeZone()
  const companyHeader = useSelector(selectCompanyInfo)
  const highlights = useSelector(selectHighlight)
  const isLoading = useSelector(selectLoading('highlight'))
  const userType = useSelector(selectUserType)
  const AUTHORIZATION_API = useSelector(selectComponentAuthorized)

  if (!isLoading && !Object.values(highlights).length) return null

  const goToPreferenceSetting = () => {
    if (isDisable) {
      EventEmitter.dispatch(SHOW_POPUP_UPGRADE)
    } else {
      setIsShowPreferenceSetting(true)
    }
  }

  const isDisable =
    AUTHORIZATION_API.companyAnalysis.preferenceSettings[
      userType.userTypeId
    ] === AUTHORIZATION_TYPE.DISABLE

  return (
    <HighlightInformation
      isLoading={isLoading}
      isWarningWhenNotHasPanel
      goToSettingPanel={goToPreferenceSetting}
      highlights={getHighlightData({
        rawData: highlights,
        comType: companyHeader.companyType,
        locale,
        timezone,
      })}
    />
  )
}
